module.exports = __webpack_public_path__ + "img/base_bg1.d81371c4.jpg";